import gql from 'graphql-tag'

export const getSubscriptionDiscount = gql`
  query csGetProductDiscount (
    $input: [CsProductInput]
  ){
    csGetProductDiscount(input: $input) {
      products {
        product_id
        free_shipping
        frequency
        discount
      }
    }
  }
`

export const getCustomerSubscriptions = gql`
  {
    customerSubscriptions {
      items {
        id
        halo_order_id
        subscription_id
        order_number
        created_at
        grand_total
        status
        PDPID
        frequency_in_cart
        name
        options {
          label
          value
        }
        package_qty
        price
        qty
        sku
        thumbnail
      }
    }
  }
`

export const updateSubscription = gql`
  mutation updatePDPOrder (
    $OrderID: Int
    $PDPID: Int!
    $PDPInterval: Int!
    $PDPIntervalType: String!
    $Quantity: Int!
    $Status: String!
    $SkuID: String!
    $id: Int
  ){
  updatePDPOrder (
      PDPID: $PDPID
      Status: $Status
      PDPInterval: $PDPInterval
      PDPIntervalType: $PDPIntervalType
      Quantity: $Quantity
      OrderID: $OrderID
      SkuID: $SkuID
      id: $id
  ) {
      message
      error
  }
}
`
